"use client";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

interface RatingOverviewProps {
  overallRating: number;
  totalReviews: number;
}

export function RatingOverview({
  overallRating,
  totalReviews,
}: RatingOverviewProps) {
  return (
    <div className="text-center lg:text-left">
      <div className="flex items-center justify-center lg:justify-start mb-4">
        <span className="text-6xl font-bold text-foreground mr-4">
          {overallRating}
        </span>
        <div>
          <div className="flex items-center mb-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star
                key={i}
                className={`h-6 w-6 ${
                  i < Math.floor(overallRating)
                    ? "fill-yellow-400 text-yellow-400"
                    : "text-muted-foreground"
                }`}
              />
            ))}
          </div>
          <p className="text-muted-foreground">
            Based on {totalReviews} reviews
          </p>
        </div>
      </div>
      <p className="text-lg text-muted-foreground mb-6">
        Join thousands of satisfied customers who chose Concretta microcement
        for their projects.
      </p>
    </div>
  );
}

interface RatingOverviewSectionProps extends RatingOverviewProps {
  children: React.ReactNode;
}

export function RatingOverviewSection(props: RatingOverviewSectionProps) {
  return (
    <section id="reviews-overview" className="py-16" data-header-scheme="light">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <RatingOverview {...props} />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {props.children}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
